var map = {
	"./locale-provider/ar_EG.tsx": 982,
	"./locale-provider/bg_BG.tsx": 986,
	"./locale-provider/ca_ES.tsx": 990,
	"./locale-provider/cs_CZ.tsx": 994,
	"./locale-provider/de_DE.tsx": 998,
	"./locale-provider/el_GR.tsx": 1002,
	"./locale-provider/en_GB.tsx": 1006,
	"./locale-provider/en_US.tsx": 1010,
	"./locale-provider/es_ES.tsx": 1011,
	"./locale-provider/et_EE.tsx": 1015,
	"./locale-provider/fa_IR.tsx": 1019,
	"./locale-provider/fi_FI.tsx": 1023,
	"./locale-provider/fr_BE.tsx": 1027,
	"./locale-provider/fr_FR.tsx": 1031,
	"./locale-provider/is_IS.tsx": 1035,
	"./locale-provider/it_IT.tsx": 1039,
	"./locale-provider/ja_JP.tsx": 1043,
	"./locale-provider/ko_KR.tsx": 1047,
	"./locale-provider/nb_NO.tsx": 1051,
	"./locale-provider/nl_BE.tsx": 1055,
	"./locale-provider/nl_NL.tsx": 1059,
	"./locale-provider/pl_PL.tsx": 1063,
	"./locale-provider/pt_BR.tsx": 1067,
	"./locale-provider/pt_PT.tsx": 1071,
	"./locale-provider/ru_RU.tsx": 1075,
	"./locale-provider/sk_SK.tsx": 1079,
	"./locale-provider/sr_RS.tsx": 1083,
	"./locale-provider/sv_SE.tsx": 1087,
	"./locale-provider/th_TH.tsx": 1091,
	"./locale-provider/tr_TR.tsx": 1095,
	"./locale-provider/uk_UA.tsx": 1097,
	"./locale-provider/vi_VN.tsx": 1101,
	"./locale-provider/zh_CN.tsx": 1105,
	"./locale-provider/zh_TW.tsx": 1108
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 981
// module chunks = 0